import React from "react";
import Image from "next/image";

const BridgeBannerMob = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -100;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };
  return (
    <>
      <div className="w-full bg-white">
        <div className="max-h-full px-5 relative bg-center bg-[url(/images/ban.png)] bg-inherit bg-repeat bg-auto bg-[length:100% 100%] pb-[30px] overflow-hidden">
          <div className="mx-auto text-[#030F1C] z-10 relative">
            <div className="flex justify-between flex-wrap items-center">
              <div className="pt-[50px] pb-[00px] w-full relative mt-20 mb-2">
                <div className="text-center relative mt-4">
                  <div className="flex flex-col gap-2 justify-center pt-6">
                    <p className="text-[#202852] text-center text-[24px] not-italic font-bold leading-[30px]">
                      With Miles' Approved
                      <br /> Bridge Program, You can
                      <br /> now appear for the CPA
                      <br /> exam with a 3-year
                      <br /> Bachelors' Degree from
                      <br /> India
                    </p>
                    <div className="flex justify-center mt-2">
                      <p className="text-[#0C1F33] bg-[#FFF] border-2 border-[#FFA548] font-semibold rounded-xl text-[12px] leading-[15px] text-center py-2 px-14">
                        India's Only CPA-Integrated Online M.Com,
                        <br /> Approved for Pre-educational Eligibility
                      </p>
                    </div>
                  </div>

                  <div
                    id=""
                    className="text-center mx-auto md:mt-12 mt-6 md:hidden block"
                  >
                    <div className=" flex justify-center">
                      <div
                        className="grp_btn justify-center items-center font-semibold !px-12 py-3 text-[13px] !bg-[#3174d6] text-white rounded-[8px]"
                        onClick={() =>
                          scrollToSection("CPA Eligibility Requirement")
                        }
                      >
                        Know More
                      </div>
                    </div>
                  </div>

                  <div className="mt-5">
                    <div className="banner_card">
                      <div className="flex items-center justify-between text-[#000] shadow-blue-200">
                        <div>
                          <p className="text-center text-[20px] not-italic font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            70,000+
                          </p>
                          <p className="text-center text-[10px] not-italic font-medium leading-[normal] tracking-[-0.48px] capitalize mt-1">
                            Global Alumni
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            600+
                          </p>
                          <p className="text-center text-[10px] not-italic font-medium leading-[normal] tracking-[-0.48px] capitalize mt-1">
                            Corporate Partnerships
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            100+
                          </p>
                          <p className="text-center text-[10px] not-italic font-medium leading-[normal] tracking-[-0.48px] capitalize mt-1">
                            Universities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Image
            src="/cpa/bridge-course/bridge-bannerMob.png"
            alt="bridge program"
            className="absolute top-[-1%] bottom-0 right-0 left-0 md:hidden block w-full"
            width={464}
            height={219}
            priority
          />
        </div>
      </div>
    </>
  );
};
export default BridgeBannerMob;
